import React from "react";
import { EditOutlined } from "@mui/icons-material";
import { Button, Divider } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import EnableDisableButton from "components/Shared/EnableDisableButton";
import ConsolidationBasicDetail from "./ConsolidationComponents/ConsolidationBasicDetail";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import {
    ConsolidationDetailContext,
    useConsolidationDetailContext,
} from "contexts/ConsolidationDetailContext";
import {
    useGetConsolidationDetailQuery,
    useUpdateConsolidationMutation,
} from "store/services/consolidationApi";

import ConsolidationDetailTab from "./ConsolidationComponents/ConsolidationDetailTab";
import { useAuth } from "hooks";

const ConsolidationDetailScreen = () => {

    const { id } = useParams();

    const breadcrumb = [
        { title: "Consolidation", path: "/app/crm/consolidation/list" },
        { title: "Consolidation Detail" },
    ];
    const {
        data: consolidationDetail,
        isLoading: loadingConsolidation,
        error,
    } = useGetConsolidationDetailQuery(id);


    return (
        <ConsolidationDetailContext.Provider value={{ consolidationDetail, loadingConsolidation }}>
            <BreadcrumbLayout
                breadcrumbs={breadcrumb}
                isBusy={loadingConsolidation}
                headerActions={<PageActions />}
            >
                <BreadcrumbLayout.Error error={error} />
                <BreadcrumbLayout.Paper>
                    <ConsolidationBasicDetail />
                    <Divider />
                    <ConsolidationDetailTab />
                </BreadcrumbLayout.Paper>
            </BreadcrumbLayout>
        </ConsolidationDetailContext.Provider>
    );
};

export default ConsolidationDetailScreen;

const PageActions = () => {

    const { isAccountAdmin } = useAuth();
    
    const { consolidationDetail, loadingConsolidation } = useConsolidationDetailContext();

    const [updateConsolidation, { isLoading: updatingConsolidation }] =
        useUpdateConsolidationMutation();

    const handleToggleStatus = async () => {
        try {
            await updateConsolidation({
                _id: consolidationDetail._id,
                isActive: !consolidationDetail.isActive,
            }).unwrap();
            toast.info(`Consolidation ${consolidationDetail.isActive ? "Disabled" : "Enabled"}!`);
        } catch (error) {
            toast.error(error?.data?.message ?? "Could Not Update Status");
        }
    };

    return (
        <div className="flex space-x-4">
            {isAccountAdmin && (<EnableDisableButton
                isActive={consolidationDetail?.isActive}
                loading={loadingConsolidation || updatingConsolidation}
                onClick={handleToggleStatus}
            />)}
            <Link to={`/app/crm/consolidation/${consolidationDetail?._id}/edit`}>
                <Button startIcon={<EditOutlined />} variant="contained">
                    Edit
                </Button>
            </Link>
        </div>
    );
};
